export const SELECT_LIST = [
  {
    label: "-",
    indexLabel: "-",
    value: null,
    bg: "#FFFFFF",
    display: true,
  },
  {
    label: "作業中",
    indexLabel: "一部作業中",
    value: "in_progress",
    bg: "#9dc3ff",
    display: true,
  },
  {
    label: "完了",
    indexLabel: "すべて完了",
    value: "completed",
    bg: "#dbffd6",
    display: true,
  },
  {
    label: "保留中",
    indexLabel: "一部保留中",
    value: "pending",
    bg: "#ffd6d6",
    display: true,
  },
  {
    label: "一部完了",
    indexLabel: "一部完了",
    value: "in_completed",
    bg: "#bceaed",
    display: false,
  },
]

export default SELECT_LIST
